<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index" :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <!-- <div class="trigger">
          <span>{{ detailData.name }}</span>
          <div style="width: 44%;">
            <el-tooltip effect="dark" placement="right">
              <div slot="content" class="rightCenter">

                <div class="describe">
                  <span>触发条件:</span>
                  <span>①设备触发：当设备达到预设的条件则触发指定的动作，设备触发条件可以多个。</span>
                  <span>②设备离线触发：当设备离线则触发指定的动作，设备离线触发条件只有一个。</span>
                </div>
                <div class="describe">
                  <span style="padding: 20px 0 10px 0;">过滤条件:</span>
                  <span>①时间过滤(此条件只在设备触发条件下才能设置)：设置了该条件后，则在设置的时间段内才会告警。</span>
                  <span>②状态持续时长(此条件只在设备离线条件触发下才能设置)：设置了该条件后，则表示设备离线持续了设定的时长(分钟)后才触发指定的动作</span>
                </div>
                <div class="describe">
                  <span style="padding: 20px 0 10px 0;">执行动作(当触发条件和过滤条件都满足的情况下执行动作):</span>
                  <span>①设备输出：当条件满足，执行设备输出，控制设备。</span>
                  <span>②告警输出：当条件满足，执行告警输出，可在告警中心模块配置告警提醒。</span>
                </div>

              </div>
              <i class="el-icon-warning" style="font-size: 20px;"></i>
            </el-tooltip>
          </div>

        </div> -->
        <h1>{{ detailData.name }}</h1>
        <!-- <h1>{{ detailData.name }}</h1> -->
        <i v-if="detailData.enable == 0" class="redDot"></i>
        <i v-if="detailData.enable == 1" class="greenDot"></i>
        <h2>
          {{
            detailData.enable == 1
              ? "启用"
              : detailData.enable == 0
              ? "停用"
              : "---"
          }}
        </h2>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;">
          <el-tab-pane label="规则列表">
            <h1>
              规则列表
              <el-button @click="addRuleDialog = true" size="mini" type="primary" style="float:right;">创建</el-button>
            </h1>
            <el-table v-loading="loading" :data="rulesData" style="width: 100%">
              <el-table-column label="规则名称">
                <template slot-scope="scope">
                  <el-link :underline="false" class="tableButton" type="primary" @click="detailBtn(scope.row.id)">
                    {{ scope.row.name }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="规则描述"></el-table-column>
              <el-table-column prop="enable" label="状态">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.enable" active-color="#13ce66" inactive-color="#ff4949" @change="enableSwitchChange(scope.row)">
                  </el-switch>
                  <span v-if="scope.row.enable == false"> 停用</span>
                  <span v-else-if="scope.row.enable == true">启用</span>
                  <span v-else>---</span>
                </template>
              </el-table-column>
              <el-table-column label="">
                <template slot-scope="scope">
                  <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="rulesCommand">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'edit', id: scope.row.id }">编辑</el-dropdown-item>
                      <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="rulesSizeChange" @current-change="rulesCurrentChange" :current-page="rulesCurrentPage" :page-sizes="[5, 10]" :page-size="rulesPageSize" layout="total, sizes, prev, pager, next, jumper" :total="rulesTotal">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="策略说明">
            <h1>策略说明</h1>
            <el-row class="formRow">
              <el-col :span="24">
                {{ detailData.instruction }}
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>
                    {{
                      detailData.createId != null ? detailData.createId : "---"
                    }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 创建规则 -->
    <el-dialog class="floorDialog" :show-close="false" title="创建规则" :visible.sync="addRuleDialog" width="400px">
      <el-form :model="addRuleForm" ref="addRuleForm">
        <el-form-item label="规则名称" style="background-color:transparent;border-bottom:none" prop="name" :rules="[{ required: true, message: '规则名称不能为空' }]">
          <el-input v-model="addRuleForm.name" placeholder="请输入" autocomplete="off" style="margin-top:5px;width:100%;" maxlength="100">
          </el-input>
        </el-form-item>
        <el-form-item label="规则说明" style="background-color:transparent;border-bottom:none">
          <el-input style="margin-top:5px;width:100%;" type="textarea" :rows="3" v-model="addRuleForm.remark" placeholder="请输入" maxlength="500"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRuleDialog = false">取 消</el-button>
        <el-button type="primary" @click="addRuleConfirm('addRuleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改规则 -->
    <el-dialog class="floorDialog" :show-close="false" title="修改规则" :visible.sync="editRuleDialog" width="400px">
      <el-form :model="editRuleForm" ref="editRuleForm">
        <el-form-item label="规则名称" style="background-color:transparent;border-bottom:none" prop="name" :rules="[{ required: true, message: '规则名称不能为空' }]">
          <el-input v-model="editRuleForm.name" placeholder="请输入" autocomplete="off" style="margin-top:5px;width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="规则说明" style="background-color:transparent;border-bottom:none">
          <el-input style="margin-top:5px;width:100%;" type="textarea" :rows="3" v-model="editRuleForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editRuleDialog = false">取 消</el-button>
        <el-button type="primary" @click="editBtn('editRuleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../../api/api";
import dayjs from "dayjs";
export default {
  data() {
    return {
      routeList: this.$route.meta.routeList,
      loading: false, //加载条
      ids: this.$route.query.id,
      detailData: {}, //详情数据
      rulesData: [], //规则table数据
      rulesCurrentPage: 1,
      rulesPageSize: 5,
      rulesTotal: 0,
      addRuleDialog: false, //创建规则弹框
      addRuleForm: {}, //创建规则内容
      editRuleDialog: false, //修改规则弹框
      editRuleForm: {}, //修改规则内容
    };
  },
  methods: {
    //初始化时间
    changeDate(time) {
      return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
    },
    //页面进来初始化
    init() {
      this.getBuildingViews();
      this.getplatformRuleEnginePage();
    },

    //获取详情数据
    getBuildingViews() {
      API.platformRuleStrategy(this.ids).then(res => {
        if (res.code == 1) {
          this.detailData = res.data;
        }
      });
    },

    /*****************************规则列表B************************************* */

    //获取规则分页
    getplatformRuleEnginePage() {
      this.loading = true; /*显示加载条*/
      let para = {
        strategyId: this.ids,
        pageSize: this.rulesPageSize,
        currentPage: this.rulesCurrentPage
      };
      API.platformRuleEnginePage(para).then(res => {
        if (res.code == 1) {
          res.data.resultPage.forEach(element => {
            if (element.enable == 1) {
              element.enable = true;
            } else {
              element.enable = false;
            }
          });
          this.rulesData = res.data.resultPage;
          this.rulesTotal = res.data.total;
        }
        this.loading = false;
      });
    },
    rulesSizeChange(val) {
      this.rulesPageSize = val;
      this.getplatformRuleEnginePage();
    },
    rulesCurrentChange(val) {
      this.rulesCurrentPage = val;
      this.getplatformRuleEnginePage();
    },
    //状态更改的回调
    enableSwitchChange(row) {
      let para = {
        enable: row.enable == false ? 0 : 1,
        name: row.name,
        remark: row.remark,
        id: row.id,
        strategyId: this.ids
      };
      //切换状态的时候调用修改规则接口
      API.editplatformRuleEngine(row.id, para).then(res => {
        if (res.code == 1) {
          this.$message.success("修改状态成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //创建规则
    addRuleConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            name: this.addRuleForm.name,
            remark: this.addRuleForm.remark,
            strategyId: this.ids
          };
          API.addPlatformRuleEngine(para).then(res => {
            if (res.code == 1) {
              this.$message.success("创建规则成功");
              this.$router.push({
                path: "/rules/ruleCondition",
                query: {
                  id: res.data,
                  strategyId: this.ids
                }
              });
              this.addRuleDialog = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请填写完必填项");
          return false;
        }
      });
    },
    //修改规则
    editBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            id: this.editRuleForm.id,
            name: this.editRuleForm.name,
            remark: this.editRuleForm.remark
          };
          API.editplatformRuleEngine(this.editRuleForm.id, para).then(res => {
            if (res.code == 1) {
              this.$message.success("修改规则成功");
              this.editRuleDialog = false;
              this.$router.push({
                path: "/rules/ruleCondition",
                query: {
                  id: this.editRuleForm.id,
                  strategyId: this.ids,
                  flag: "edit"
                }
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请填写完必填项");
          return false;
        }
      });
    },
    //规则列表操作
    rulesCommand(para) {
      let ids = para.id;
      if (para.type == "edit") {
        //编辑弹框
        this.editRuleDialog = true;
        API.platformRuleEngine(ids).then(res => {
          if (res.code == 1) {
            this.editRuleForm = res.data;
          }
        });
      } else if (para.type == "del") {
        //删除规则
        let para = {
          ids: ids
        };
        this.$confirm("此操作将永久删除该规则, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            API.delPlatformRuleEngine(para).then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getplatformRuleEnginePage();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    //跳详情
    detailBtn(id) {
      this.$router.push({
        path: "/rules/ruleCondition",
        query: {
          id: id,
          strategyId: this.ids,
          flag: "edit"
        }
      });
    },
    /*****************************规则列表E************************************* */

    //操作下拉
    handleCommand(para) {
      if (para == "del") {
        //删除
        let para = {
          ids: this.ids
        }
        this.$confirm('此操作将永久删除该策略, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformRuleStrategy(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.$router.push({
                path: "/rules/sceneLinkage",
              });
            } else {
              this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};

</script>




// WEBPACK FOOTER //
// src/views/platform/ruleEngineList.vue